import { Box } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const StyledBackground = styled(Box, {
  base: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
    flex: 1,
    alignSelf: 'stretch',
  },
});
